<script setup>
import { mdiCheck } from '@mdi/js'
import { useRoute } from 'vue-router'
import { useInspectionStore } from '@/stores/inspection-store'
import { Notify } from '@/modules/util/notify'
import CameraInput from '@/components/inputs/CameraInput.vue'
import { getImageService } from '@/services/image-service'

const store = useInspectionStore()
const imageService = getImageService(store.currentInspection)
const route = useRoute()
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const uploadMileagePhoto = async (value) => {
	const res = await imageService.uploadInspection(route.params.id, value.url)
	if (!res) {
		Notify.error('Image upload failed')
		return
	}

	value.uid = res.uid
	delete value.url

	emit('update:modelValue', value)
}
</script>

<template>
<div>
	<CameraInput
		class="w-100"
		:color="props.modelValue ? 'success' : 'primary'"
		:append-icon="props.modelValue ? mdiCheck : undefined"
		@update="uploadMileagePhoto"
	>
		{{ props.modelValue ? 'Mileage Picture Taken' : field.label }}
	</CameraInput>
</div>
</template>

<style lang="scss" scoped>

</style>